import React, {Component} from 'react';

import ReactExport from "react-export-excel";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

class ExcelDownBtn extends Component {
	constructor(props) {
		super(props);
	}

	render() {

		return (
			<ExcelFile filename={this.props.fileName || "EXCEL DOWN"} element={this.props.btn || <button className="btn btn-info">ExcelDown</button>}>
	            <ExcelSheet dataSet={this.props.dataSet} name={this.props.name}/>
	        </ExcelFile>
		)
	}
}

export default ExcelDownBtn;